import type { DehydratedState } from "@tanstack/react-query";
import type { AnyRouter } from "@tanstack/react-router";

// 캐시 블록 id 는 프리렌더(scripts/prerender.mjs)·Worker SSR(worker/ssr.tsx)과 한 벌(lib/state-script.mjs).
export { PRERENDER_STATE_ID } from "@/lib/state-script.mjs";

interface StateBlock {
  textContent: string | null;
  getAttribute(name: string): string | null;
}

// 블록이 지금 주소를 그린 것일 때만 캐시를 꺼낸다 — 받은 시각은 지금으로 바꿔 hydrate 직후 같은 읽기를 다시 묻지(한도를 두 번 세지) 않게.
export const readPrerenderState = (
  block: StateBlock | null,
  here: { pathname: string; search: string },
  now = Date.now(),
): DehydratedState | null => {
  if (!block || block.getAttribute("data-url") !== `${here.pathname}${here.search}`) return null;
  try {
    const state = JSON.parse(block.textContent ?? "") as DehydratedState | null;
    if (!state || !Array.isArray(state.queries) || !Array.isArray(state.mutations)) return null;
    return { ...state, queries: state.queries.map((query) => ({ ...query, state: { ...query.state, dataUpdatedAt: now } })) };
  } catch {
    return null;
  }
};

// hydrate 할 라우터는 서버처럼 맨 위 Suspense 를 두지 않는다(TanStack Start 가 hydrate 때 거는 표시와 같다) — 두면 서버 HTML 에 없는 경계라 어긋난다.
export const markHydrating = (router: AnyRouter): void => {
  router.ssr = { manifest: undefined };
};
